export const IMPORT_TYPE = {
    PRODUCTS: "products",
    MATRIX_PRODUCTS: "products-matrix",
    CONTACTS: "contacts",
    SUPPLIERS: "suppliers",
}

export const PRODUCT_IMPORT_TYPE = [IMPORT_TYPE.PRODUCTS, IMPORT_TYPE.MATRIX_PRODUCTS]


// WEBPACK FOOTER //
// ./src/utils/external/constants.ts